import Practice from "app/models/practice"
import { Action, Types } from "./practice.actions"

export type PracticeState = {
  data: Practice | undefined
  errors: {}
  loading: boolean
}

const initialState: PracticeState = {
  data: undefined,
  errors: {},
  loading: false,
}

export default (state = initialState, action: Action): PracticeState => {
  switch (action.type) {
    case Types.GET:
      return {
        ...state,
        loading: true,
      }

    case Types.GET_SUCCESS:
      return {
        ...state,
        data: action.payload.data,
        loading: false,
      }

    case Types.GET_FAIL:
      return {
        ...state,
        errors: action.payload.errors,
        loading: false,
      }

    case Types.PUT:
    case Types.PUT_FEATURES:
      return {
        ...state,
        loading: true,
      }

    case Types.PUT_SUCCESS:
      return {
        ...state,
        loading: false,
      }

    case Types.PUT_FEATURES_SUCCESS:
      return {
        ...state,
        data: action.payload.data,
        loading: false,
      }

    case Types.PUT_FAIL:
    case Types.PUT_FEATURES_FAIL:
      return {
        ...state,
        errors: action.payload.errors,
        loading: false,
      }

    default:
      return state
  }
}
